import { Paths } from './paths/paths';
import { apiSlice } from './apiSlice';
import { NomineeAgent } from './response/NomineeAgent';

export const nomineeAgentSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    nomineeAgents: builder.query<NomineeAgent[], void>({
      query: () => Paths.NomineeAgent,
      providesTags: ['nominee_agents'],
    }),
    createNomineeAgent: builder.mutation<
      NomineeAgent,
      Omit<NomineeAgent, 'id'>
    >({
      query: (data) => ({
        url: Paths.NomineeAgent,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['nominee_agents'],
    }),
    updateNomineeAgent: builder.mutation<
      NomineeAgent,
      Omit<NomineeAgent, 'email'>
    >({
      query: (data) => ({
        url: Paths.NomineeAgent,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['nominee_agents'],
    }),
    deleteNomineeAgent: builder.mutation<void, { nomineeAgentId: number }>({
      query: (data) => ({
        url: Paths.NomineeAgent,
        method: 'DELETE',
        params: { nomineeAgentId: data.nomineeAgentId},
      }),
      invalidatesTags: ['nominee_agents'],
    }),
    sendNomineeEmailVerificationRequest: builder.mutation<
      void,
      { nomineeAgentId: number }
    >({
      query: (data) => ({
        url: Paths.NomineeAgentEmailVerification,
        method: 'POST',
        params: { nomineeAgentId: data.nomineeAgentId},
      }),
    }),
    sendNomineePasswordResetRequest: builder.mutation<
      void,
      { nomineeAgentId: number }
    >({
      query: (data) => ({
        url: Paths.NomineeAgentPasswordReset,
        method: 'POST',
        params: { nomineeAgentId: data.nomineeAgentId},
      }),
    }),
  }),
});

export const {
  useNomineeAgentsQuery,
  useCreateNomineeAgentMutation,
  useUpdateNomineeAgentMutation,
  useDeleteNomineeAgentMutation,
  useSendNomineeEmailVerificationRequestMutation,
  useSendNomineePasswordResetRequestMutation,
} = nomineeAgentSlice;
